import React, { PureComponent } from 'react'
import { string, shape, func } from 'prop-types'
import Input from '@active/react-ui/Input'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormField from '@active/react-ui/FormField'
import Form, { FormConsumer } from '@active/react-ui/Form'
import RadioGroup from '@active/react-ui/RadioGroup'
import Radio from '@active/react-ui/Radio'
import { Locale, withI18n } from '@active/react-utils/i18n'
import noop from 'lodash/noop'

import BitMap from '../../../imgs/bitmap.png'
import handleKeyUp from '../../../utils/numberHandler'
import { accountNumberValidatorBuilder } from '../../../utils/validators'
import './ECheckFields.scss'
import { handleKeyboardEvent } from '../../../../../../../shared/utils/commonUtils'

class ECheckFields extends PureComponent {
  static propTypes = {
    fields: shape({
      accountName: string,
      bankRoutingNumber: string,
      accountNumber: string,
      accountType: string,
    }).isRequired,
    name: string.isRequired,
    fieldsChangeCallBack: func.isRequired,
    submitFieldsTrigger: func.isRequired,
    i18n: func.isRequired,
  }

  submitFormTrigger = noop

  constructor(props) {
    super(props)
    this.state = {
      isShowBitMap: false,
    }
  }

  componentDidMount() {
    const { submitFieldsTrigger } = this.props
    submitFieldsTrigger(this.submitFormTrigger)
  }

  handleSubmit = values => {
    const { fieldsChangeCallBack } = this.props
    fieldsChangeCallBack(values)
  }

  handleClick = () => {
    const { isShowBitMap } = this.state
    this.setState({
      isShowBitMap: !isShowBitMap,
    })
  }

  render() {
    const { fields, name, i18n } = this.props
    const { isShowBitMap } = this.state
    return (
      <div className="checkout__echeck-fields">
        <Form
          horizontal
          name={name}
          initialValues={fields}
          onSubmit={this.handleSubmit}
        >
          <FormGroup required>
            <FormLabel><Locale id="passport.lib.components.payment.echeck.name" /></FormLabel>
            <FormField
              name="accountName"
              min={0}
              maxLength={50}
              as={Input}
            />
          </FormGroup>
          <FormGroup required>
            <FormLabel><Locale id="passport.lib.components.payment.echeck.routing" /></FormLabel>
            <FormField
              name="bankRoutingNumber"
              onKeyUp={handleKeyUp}
              maxLength={9}
              as={Input}
            />
          </FormGroup>
          <FormGroup required>
            <FormLabel><Locale id="passport.lib.components.payment.echeck.account" /></FormLabel>
            <FormField
              name="accountNumber"
              onKeyUp={handleKeyUp}
              as={Input}
              validate={accountNumberValidatorBuilder()}
            />
          </FormGroup>
          <FormGroup name="accountType" required>
            <FormLabel verticalStart><Locale id="passport.lib.components.payment.echeck.type" /></FormLabel>
            <FormField as={RadioGroup} defaultValue="CONSUMER_CHECKING">
              <Radio className="checkout__echeck-fields--accountType" value="CONSUMER_CHECKING"><Locale id="passport.lib.components.payment.echeck.CONSUMER_CHECKING" /></Radio>
              <Radio className="checkout__echeck-fields--accountType" value="CORPORATE_CHECKING"><Locale id="passport.lib.components.payment.echeck.CORPORATE_CHECKING" /></Radio>
              <Radio className="checkout__echeck-fields--accountType" value="CONSUMER_SAVINGS"><Locale id="passport.lib.components.payment.echeck.CONSUMER_SAVINGS" /></Radio>
              <Radio className="checkout__echeck-fields--accountType" value="CORPORATE_SAVINGS"><Locale id="passport.lib.components.payment.echeck.CORPORATE_SAVINGS" /></Radio>
            </FormField>
          </FormGroup>
          <FormConsumer>
            {({ form }) => {
              this.submitFormTrigger = form.submitForm
              return null
            }}
          </FormConsumer>
        </Form>
        <div className="checkout__echeck-fields__bitmap">
          <span
            tabIndex={0}
            role="button"
            aria-labelledby="bitmap-hint"
            aria-expanded={isShowBitMap}
            className="checkout__echeck-fields__bitmap--text"
            onClick={this.handleClick}
            onKeyDown={handleKeyboardEvent(this.handleClick, ['Enter', ' '])}
          >
            <i className={`payment-mr5 ic-triangle-${isShowBitMap ? 'down' : 'right'}`} />
            <span id="bitmap-hint">
              <Locale id="passport.lib.components.payment.echeck.hint" />
            </span>
          </span>
          {
            isShowBitMap && <img src={BitMap} alt={i18n('passport.lib.components.achNumber.label.hint.img')} />
          }
        </div>
      </div>
    )
  }
}

export default withI18n(ECheckFields)
